import React from 'react';
import NavBar from "../Components/NavBar";
import ccpic01 from "./pose_eat01.png"
export default () => (
    <>
        <NavBar/>
        <h1>404: Page not found.</h1>
        <img className="NFpic" src={ccpic01} alt="C.C. eating"></img>
    </>
);